<template>
  <div class="row">
    <div class="col">
      <div class="card">
        <div class="card-body p-0">
          <cardHead
            :title="'Mails'"
            :buttons="[
              {
                title: 'To Read Queues',
                icon: 'fa fa-boxes',
                emit: 'toReadQueues',
                class: 'btn-warning',
              },
              {
                title: 'Unvisible',
                icon: 'fa fa-eye-slash',
                emit: 'unVisible',
                class: 'btn-success',
              },
              /*{
                title: 'Scan',
                icon: 'fa fa-search',
                emit: 'scan',
              },
              {
                title: 'Forgotten Scan',
                icon: 'fa fa-qrcode',
                emit: 'forgottenScan',
                class: 'btn-info',
              },*/
            ]"
            @scan="scan()"
            @toReadQueues="toReadQueues()"
            @unVisible="unVisible()"
            @forgottenScan="openForgottenScan = true"
          ></cardHead>
          <Form
            method="dialog"
            v-slot="{ errors }"
            class="floating-labels row  p-20 p-b-10"
            ref="form"
          >
            <div class="col-8">
              <formGroup
                :title="'Subject'"
                v-model="model.Subject"
                :errors="errors"
                @keydown.enter="get"
              ></formGroup>
            </div>
            <div class="col-2"
                style="padding-top: 8px;">
              <formGroup
                :title="'From Address Required'"
                as="checkbox"
                v-model="model.IsFromAddressRequired"
                :errors="errors"
                @keydown.enter="get"
                class="m-0"
              ></formGroup>
            </div>
            <div class="col-2"
                style="padding-top: 8px;">
              <formGroup
                :title="'To Address Required'"
                as="checkbox"
                v-model="model.IsToAddressRequired"
                :errors="errors"
                @keydown.enter="get"
              ></formGroup>
            </div>
            <div class="col">
              <formGroup
                :title="'BeginReceiveDate'"
                :type="'date'"
                :max="model.EndReceiveDate"
                v-model="model.BeginReceiveDate"
                :errors="errors"
                @keydown.enter="get"
              ></formGroup>
              <formGroup
                :title="'EndReceiveDate'"
                :type="'date'"
                :min="model.BeginReceiveDate"
                v-model="model.EndReceiveDate"
                :errors="errors"
                @keydown.enter="get"
              ></formGroup>
            </div>
            <div class="col">
              <formGroup
                :title="'BeginMailDate'"
                :type="'date'"
                :max="model.EndMailDate"
                v-model="model.BeginMailDate"
                :errors="errors"
                @keydown.enter="get"
              ></formGroup>
              <formGroup
                :title="'EndMailDate'"
                :type="'date'"
                :min="model.BeginMailDate"
                v-model="model.EndMailDate"
                :errors="errors"
                @keydown.enter="get"
              ></formGroup>
            </div>
            <div class="col">
              <searchSelect
                :title="'CustomerId'"
                :disabled="customers.length == 0"
                v-model="model.CustomerId"
                :errors="errors"
                :data="[
                  { value: null, text: 'All' },
                  ...customers.map((x) => {
                    return {
                      value: x.Id,
                      text: x.Name,
                    };
                  }),
                ]"
              >
                <!-- <template #input>
                  <option :value="null">All</option>
                  <option
                    v-for="item in customers"
                    :value="item.Id"
                    :key="item.Id"
                    >{{ item.Name }}</option
                  >
                </template> -->
              </searchSelect>
              <searchSelect
                :title="'ProviderId'"
                :disabled="providers.length == 0"
                v-model="model.ProviderId"
                :errors="errors"
                :data="[
                  { value: null, text: 'All' },
                  ...providers.map((x) => {
                    return {
                      value: x.Id,
                      text: x.Name,
                    };
                  }),
                ]"
              >
                <!-- <template #input>
                  <option :value="null">All</option>
                  <option
                    v-for="item in providers"
                    :value="item.Id"
                    :key="item.Id"
                    >{{ item.Name }}</option
                  >
                </template> -->
              </searchSelect>
            </div>
            <div class="col">
              <formGroup
                :title="'FromAddress'"
                v-model="model.FromAddress"
                :errors="errors"
              ></formGroup>
              <formGroup
                :title="'ToAddress'"
                v-model="model.ToAddress"
                :errors="errors"
              ></formGroup>
            </div>
            <div class="col" style="min-width: 400px;">
              <div class="row">
                <div class="col-4">
                  <formGroup
                    :title="'MailId'"
                    v-model="model.MailId"
                    :errors="errors"
                  ></formGroup>
                </div>
                <div class="col-4">
                  <formGroup
                    :title="'IsRead'"
                    :as="'select'"
                    v-model="model.IsRead"
                    :errors="errors"
                  >
                    <template #input>
                      <option :value="null">All</option>
                      <option :value="true">true</option>
                      <option :value="false">false</option>
                    </template>
                  </formGroup>
                </div>
                <div class="col-4">
                  <formGroup
                    :title="'IsConverted'"
                    :as="'select'"
                    v-model="model.IsConverted"
                    :errors="errors"
                  >
                    <template #input>
                      <option :value="null">All</option>
                      <option :value="true">true</option>
                      <option :value="false">false</option>
                    </template>
                  </formGroup>
                </div>
              </div>
              <Btn
                class="btn-success w100 tcenter"
                @click="get()"
                :disabled="reportProcess"
                :process="reportProcess"
                >Get</Btn
              >
              <div class="tright">
                <Btn
                  class="btn btn-primary btn-xs btn-icon waves-effect waves-light p-r-10 m-b-0 m-t-5 m-l-0  m-r-0"
                  @click="clear"
                  :process="reportProcess"
                  v-show="isClear"
                  ><span class="btn-label m-0 p-0" style="width:28px"
                    ><i class="fas fa-eraser"></i
                  ></span>
                  <span class="p-l-20 p-r-10" style="padding-left:30px"
                    >Filter Clear</span
                  ></Btn
                >
              </div>
            </div>
          </Form>
          <div class="tables rel">
            <div
              v-show="data != null"
              class="myCheckBox abs"
              style="    top: 47px;
    z-index: 5;
    left: 5px;"
            >
              <input
                type="checkbox"
                class="filled-in"
                v-model="selectAll"
                id="chckSelectAllMails"
              /><label for="chckSelectAllMails"></label>
            </div>
            <dataTable
              :name="'kolayrezMails'"
              v-if="data != null"
              ref="agGrid"
              :columnDefs="columnDefs"
              :data="data"
              @cellClicked="rowClicked($event)"
              @read="readShow = $event?.Id"
              @convert="convertShow = $event?.Id"
              @convertSave="convertSaveShow = $event?.Id"
              :addContextMenuItem="getContextMenuItems"
              :rowClassRules="{
                // row style function
                error: (params) => {
                  // var numSickDays = params.data;
                  return params?.data?.HasError;
                },
                success: (params) => {
                  // var numSickDays = params.data;
                  return (
                    params?.data?.IsRead &&
                    params?.data?.Converted &&
                    params?.data?.ReservationCount > 0 &&
                    params?.data?.ReservationCount != null
                  );
                },
                warning: (params) => {
                  // var numSickDays = params.data;
                  return (
                    params?.data?.IsRead &&
                    params?.data?.Converted &&
                    (params?.data?.ReservationCount == 0 ||
                      params?.data?.ReservationCount == null)
                  );
                },
                info: (params) => {
                  // var numSickDays = params.data;
                  return params?.data?.IsRead && params?.data?.ManuelConvert;
                },
              }"
            ></dataTable>
            <load-area v-if="data == null" class="border-top"></load-area>
          </div>
        </div>
      </div>
      <show
        v-if="showShow != null"
        :id="showShow"
        @close="showShow = null"
        @reload="reload"
      ></show>
      <read
        v-if="readShow != null"
        :id="readShow"
        @change="changeRead($event)"
        @close="readShow = null"
      ></read>
      <convert
        v-if="convertShow != null"
        :id="convertShow"
        @close="convertShow = null"
      ></convert>
      <convertSave
        v-if="convertSaveShow != null || convertWithSubjectVoucherSaveShow!=null"
        :id="convertSaveShow!=null?convertSaveShow:convertWithSubjectVoucherSaveShow"
        :isSubjectVoucher='convertWithSubjectVoucherSaveShow!=null'
        @readSuccess="convertSave($event)"
        @close="convertSaveShow = null; convertWithSubjectVoucherSaveShow=null;"
      ></convertSave>
      <addManuelReservation
        :customers="customers"
        :mailId="addManuelReservation"
        v-if="addManuelReservation != null"
        @close="addManuelReservation = null"
      ></addManuelReservation>
      <forgottenScan
        v-if="openForgottenScan"
        @close="openForgottenScan = false"
      ></forgottenScan>
    </div>
  </div>
</template>

<script>
import show from "./show";
import read from "./read";
import convert from "./convert";
import convertSave from "./convertSave";
import addManuelReservation from "./manuelReservation/add.vue";
import forgottenScan from "./forgottenScan.vue";
import moment from "moment";
import axios from "axios";
export default {
  name: "Mails",
  components: {
    show,
    read,
    convert,
    convertSave,
    addManuelReservation,
    forgottenScan,
  },
  data() {
    return {
      customers: [],
      providers: [],
      columnDefs: [
        {
          headerName: "",
          field: "isSelect",
          enableRowGroup: true,
          floatingFilter: false,
          filter: false,
          flex: 1,
          minWidth: 30,
          cellRenderer: this.$CheckCellRenderer,
        },
        {
          headerName: "Id",
          field: "Id",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "UniqueId",
          field: "UniqueId",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "UidKey",
          field: "UidKey",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "MailDate",
          field: "MailDate",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
          valueFormatter: function(params) {
            let diff = new Date().getTimezoneOffset();
            return moment(
              new Date(params.value).setMinutes(
                new Date(params.value).getMinutes() - diff
              )
            ).format("DD.MM.YYYY HH:mm");
          },
        },
        {
          headerName: "ReceiveDate",
          field: "ReceiveDate",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
          valueFormatter: function(params) {
            let diff = new Date().getTimezoneOffset();
            return moment(
              new Date(params.value).setMinutes(
                new Date(params.value).getMinutes() - diff
              )
            ).format("DD.MM.YYYY HH:mm");
          },
        },
        {
          headerName: "FromAddress",
          field: "FromAddress",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "ToAddress",
          field: "ToAddress",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "Subject",
          field: "Subject",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 540,
          cellRenderer: function(params) {
            let isMultiple = 0;
            let text = params.data.Subject;
            params.api.forEachNodeAfterFilter((element) => {
              if (
                element.data.Subject != null &&
                params.data.Subject != null &&
                element.data.Subject.indexOf(
                  params.data.Subject.substring(
                    params.data.Subject.length / 2,
                    params.data.Subject.length
                  )
                ) > -1
              ) {
                isMultiple++;
              }
            });
            if (isMultiple > 1) {
              text = "<b>" + text + "</b>";
            }
            return text;
          },
        },
        {
          headerName: "HasAttachments",
          field: "HasAttachments",
          enableRowGroup: true,
          floatingFilter: false,
          filter: false,
          flex: 1,
          minWidth: 160,
          cellRenderer: this.$CheckCellRenderer,
        },
        {
          headerName: "IsRead",
          field: "IsRead",
          enableRowGroup: true,
          floatingFilter: false,
          filter: false,
          flex: 1,
          minWidth: 140,
          cellRenderer: this.$CheckCellRenderer,
        },
        {
          headerName: "RetryReadCount",
          field: "RetryReadCount",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 160,
        },
        {
          headerName: "Converted",
          field: "Converted",
          enableRowGroup: true,
          floatingFilter: false,
          filter: false,
          flex: 1,
          minWidth: 140,
          cellRenderer: this.$CheckCellRenderer,
        },
        {
          headerName: "ProviderId",
          field: "ProviderId",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "CustomerId",
          field: "CustomerId",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "ReservationCount",
          field: "ReservationCount",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 160,
        },
        {
          headerName: "ConfirmedReservationCount",
          field: "ConfirmedReservationCount",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 240,
        },
        {
          headerName: "IsVisible",
          field: "IsVisible",
          enableRowGroup: true,
          floatingFilter: false,
          filter: false,
          flex: 1,
          minWidth: 140,
          cellRenderer: this.$CheckCellRenderer,
        },
        {
          headerName: "ReadErrorMessage",
          field: "ReadErrorMessage",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "ConvertErrorMessage",
          field: "ConvertErrorMessage",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 200,
        },
      ],
      data: null,
      showShow: null,
      model: {
        BeginReceiveDate: null,
        EndReceiveDate: null,
        BeginMailDate: null,
        EndMailDate: null,
        ProviderId: null,
        CustomerId: null,
        IsRead: null,
        IsConverted: null,
        MailId: null,
        FromAddress: null,
        ToAddress: null,
        Subject: null,
        IsFromAddressRequired: false,
        IsToAddressRequired:false
      },
      reportProcess: true,
      report: [],
      readShow: null,
      convertShow: null,
      convertSaveShow: null,
      convertWithSubjectVoucherSaveShow:null,
      selectAll: false,
      addManuelReservation: null,
      openForgottenScan: false,
    };
  },
  created() {
    this.$appAxiosAdmin.get(`Customers`).then((response) => {
      this.customers = response.data;
    });
    this.$appAxiosAdmin.get(`kolayrez/Providers`).then((response) => {
      this.providers = response.data;
    });
    this.get();
  },
  watch: {
    // showShow(){
    //   window.open(
    //     "https://reservations.ams3.digitaloceanspaces.com/logs/"+this.showShow,
    //     '_blank' // <- This is what makes it open in a new window.
    //   );
    // }
    selectAll() {
      if (this.data == null) {
        return false;
      }
      if (!this.selectAll) {
        this.data.forEach((element) => {
          if (element.isSelect) {
            element.isSelect = false;
            this.$refs.agGrid.changeRow("Id", element);
          }
        });
        return false;
      }

      let pager = {
        min:
          this.$refs.agGrid.pager.currentPage *
          this.$refs.agGrid.pager.pageSize,
        max:
          (this.$refs.agGrid.pager.currentPage + 1) *
          this.$refs.agGrid.pager.pageSize,
      };
      this.$refs.agGrid.gridApi.forEachNodeAfterFilterAndSort(
        (rowNode, index) => {
          if (index >= pager.min && index < pager.max) {
            this.$refs.agGrid.changeRow("Id", {
              ...rowNode.data,
              isSelect: true,
            });
          }
        }
      );
    },
  },
  methods: {
    get() {
      this.data = null;
      this.selectAll = false;
      this.reportProcess = true;
      this.model.FromAddress =
        this.model.FromAddress == "" ? null : this.model.FromAddress;
      this.model.ToAddress =
        this.model.ToAddress == "" ? null : this.model.ToAddress;
      this.model.Subject = this.model.Subject == "" ? null : this.model.Subject;
      this.$appAxiosAdmin
        .post(`KOLAYREZ/Mails`, this.model)
        .then((response) => {
          this.data = [];
          response.data.forEach((element) => {
            this.data.push({
              ...element,
              isSelect: false,
            });
          });
          this.reportProcess = false;
        })
        .catch((err) => {
          this.$swal({
            icon: "error",
            title: "Error",
            text: err,
          });
          this.data = [];
          this.reportProcess = false;
        });
    },
    rowClicked(item) {
      if (item.colDef.type != "action" && item.colDef.field != "isSelect") {
        this.showShow = item?.data?.Id;
      }
      if (item.colDef.field == "isSelect") {
        // this.data.filter((x) => {
        //   return x.Id == item?.data?.Id;
        // })[0].isSelect = !item?.data?.isSelect;
        this.$refs.agGrid.changeRow("Id", {
          ...item.data,
          isSelect: !item.data.isSelect,
        });
      }
    },
    reload() {
      this.get();
    },
    truncate() {
      this.$swal({
        icon: "question",
        title: "Warning",
        text: "Are you sure you want to truncate Asyasoft logs?",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((question) => {
        if (question.isConfirmed) {
          this.$appAxiosAdmin
            .get(`KOLAYREZ/AsyasoftLogs/Truncate`)
            .then(() => {
              this.reload();
              this.$swal({
                icon: "success",
                title: "Success",
                text: "The successfully truncated.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
            })
            .catch((err) => {
              this.$isError(err);
            });
        }
      });
    },
    toReadQueues() {
      let to = [];
      this.data
        .filter((x) => {
          return x.isSelect;
        })
        .forEach((element) => {
          to.push(element.Id);
        });
      this.$appAxiosAdmin
        .post(`Kolayrez/Mails/ToReadQueues`, to)
        .then(() => {
          this.$swal({
            icon: "success",
            title: "Success",
            text: "Reservations have been added to the queue.",
            timer: 2000,
            confirmButtonText: "Okey",
          });
        })
        .catch((err) => {
          this.$isError(err);
        });
    },
    unVisible() {
      let to = [];
      this.data
        .filter((x) => {
          return x.isSelect;
        })
        .forEach((element) => {
          to.push(element.Id);
        });
      this.$appAxiosAdmin
        .post(`Kolayrez/Mails/Unvisible`, to)
        .then(() => {
          this.$swal({
            icon: "success",
            title: "Success",
            text: "Reservations successfully hidden.",
            timer: 2000,
            confirmButtonText: "Okey",
          });
          this.data
            .filter((x) => {
              return x.isSelect;
            })
            .forEach((item) => {
              this.$refs.agGrid.removeRow([item]);
            });
          this.data = this.data.filter((x) => {
            return !x.isSelect;
          });
          this.selectAll = false;
        })
        .catch((err) => {
          this.$isError(err);
        });
    },
    scan() {
      axios
        .get(`https://api.kolayrez.com/mailworker/Scan`)
        .then((response) => {
          this.$swal({
            icon: "success",
            title: "Success",
            text: response.data,
            timer: 2000,
            confirmButtonText: "Okey",
          });
        })
        .catch((err) => {
          this.$isError(err);
        });
    },
    changeRead(item) {
      this.$refs.agGrid.changeRow("Id", {
        Id: this.readShow,
        ...item,
      });
    },
    convertSave(item) {
      this.$refs.agGrid.changeRow("Id", {
        Id: this.readShow,
        ...this.$refs.agGrid.data.filter((x) => x.Id == item)[0],
        IsRead: true,
        Converted: true,
        ReservationCount: 1,
      });
    },
    getContextMenuItems(params) {
      let result = [
        "copy",
        "export",
        {
          name: "Read",
          icon: "<i class='mdi mdi-glasses'></i>",
          action: () => {
            this.readShow = params.node.data.Id;
          },
        },
        {
          name: "Convert",
          icon: "<i class='fas fa-sync-alt'></i>",
          action: () => {
            this.convertShow = params.node.data.Id;
          },
        },
        {
          name: "Convert Save",
          icon: "<i class='fas fa-save'></i>",
          action: () => {
            this.convertSaveShow = params.node.data.Id;
          },
        },
        {
          name: "Convert With Subject Voucher",
          icon: "<i class='fas fa-save'></i>",
          action: () => {
            this.convertWithSubjectVoucherSaveShow = params.node.data.Id;
          },
        },
        {
          name: "Add Manuel Reservation",
          icon: "<i class='fas fa-plus'></i>",
          action: () => {
            this.addManuelReservation = params.node.data.Id;
          },
        },
      ];
      return result;
    },
    clear() {
      this.model = {
        BeginReceiveDate: null,
        EndReceiveDate: null,
        BeginMailDate: null,
        EndMailDate: null,
        ProviderId: null,
        CustomerId: null,
        IsRead: null,
        IsConverted: null,
        MailId: null,
        FromAddress: null,
        ToAddress: null,
        Subject: null,
      };
    },
  },
  computed: {
    isClear() {
      let show = false;
      Object.entries(this.model).forEach((element) => {
        if (
          (element[1] != null && element[1] != "") ||
          element[1] == false ||
          (typeof element[1] == "object" && element[1]?.length > 0)
        ) {
          show = true;
        }
      });
      return show;
    },
  },
};
</script>
<style scoped>
.report li {
  border-left: none !important;
  border-right: none !important;
}
.report li:first-child {
  border-top: none !important;
}
.treeViewInput > div > ul {
  height: unset;
}
</style>
